import { useState } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  useTheme,
  Button,
} from '@mui/material';
import { StyledTableCellWithoutLeftRight } from 'routes/Main/style';
import Form from 'components/Form';

import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';

import SectionTitle from '../components/SectionTitle';

const contentLabel = [
  {
    id: 1,
    desc: [
      '낙상발생장소(코드번호로 기재)',
      '욕창 단계 (코드번호로 기재, 2개 이상일 경우 가장 높은 욕창 단계를 기재) ',
    ],
    scores: [8, 6],
    ids: [1, 2],
  },
];

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
}

const Contents5 = (props: Props) => {
  const { palette } = useTheme();
  const { disabled, setValue, getValues, register } = props;

  const min = 0;
  const max = 8;

  const [input1, setInput1] = useState(
    getValues('no06_01') ? Number(getValues('no06_01')) : 0
  );
  const [input2, setInput2] = useState(
    getValues('no06_02') ? Number(getValues('no06_02')) : 0
  );

  return (
    <>
      <SectionTitle title="6. 추가정보" mb={3} mt={3} />
      <Box sx={{ width: '98%', margin: '20px auto' }}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <StyledTableCellWithoutLeftRight
                align="left"
                sx={{
                  padding: '16px',
                  color: `${palette.primary.main}`,
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                항목
              </StyledTableCellWithoutLeftRight>
              <StyledTableCellWithoutLeftRight
                align="center"
                sx={{
                  padding: '16px',
                  color: `${palette.primary.main}`,
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                입력
              </StyledTableCellWithoutLeftRight>
            </TableRow>
          </TableHead>
          <TableBody>
            {contentLabel.map(
              (content: {
                id: number;
                desc: string[];
                scores: number[];
                ids: number[];
              }) => (
                <TableRow>
                  <StyledTableCellWithoutLeftRight>
                    {content.desc.map((v, i) => (
                      <TableRow
                        sx={{
                          height: '48px',
                          lineHeight: '48px',
                          borderBottom:
                            i !== content.desc.length - 1
                              ? '1px solid lightgray'
                              : '',
                          width: '100%',
                        }}
                      >
                        <Box
                          sx={{
                            paddingLeft: '16px',
                            fontSize: '12px',
                            width: '82.6vw',
                            maxWidth: '1340px',
                            minWidth: '1088px',
                            fontWeight: 500,
                          }}
                        >
                          {v}
                          <br />
                          {v === '낙상발생장소(코드번호로 기재)' && (
                            <Typography
                              sx={{
                                fontSize: '12px',
                                fontWeight: 500,
                                marginBottom: '10px',
                              }}
                            >
                              0. 발생하지 않음
                              <br /> 1.1인실 병실 내<br /> 2. 2인실 병실 내
                              <br /> 3. 3인실 병실 내<br /> 4. 4인실 이상 병실
                              내<br /> 5. 화장실 및 샤워실
                              <br /> 6. 복도
                              <br /> 7. 검사실 및 치료실
                              <br /> 8. 기타(병원로비 등)
                            </Typography>
                          )}

                          {v ===
                            '욕창 단계 (코드번호로 기재, 2개 이상일 경우 가장 높은 욕창 단계를 기재) ' && (
                            <Typography
                              sx={{
                                fontSize: '12px',
                                fontWeight: 500,
                                marginBottom: '10px',
                              }}
                            >
                              0. 발생하지 않음
                              <br /> 1. stage 1<br /> 2. stage 2<br /> 3. stage
                              3<br /> 4. stage 4<br /> 5. 단계측정불가
                              <br /> 6. 예상되는 심부조직 손상단계
                            </Typography>
                          )}
                        </Box>
                      </TableRow>
                    ))}
                  </StyledTableCellWithoutLeftRight>
                  <StyledTableCellWithoutLeftRight>
                    {content.scores.map((score, i) => {
                      return (
                        <TableRow
                          sx={{
                            height:
                              content.desc[i] ===
                              '낙상발생장소(코드번호로 기재)'
                                ? '236px'
                                : content.desc[i] ===
                                  '욕창 단계 (코드번호로 기재, 2개 이상일 경우 가장 높은 욕창 단계를 기재) '
                                ? '200px'
                                : '48px',
                            lineHeight:
                              content.desc[i] ===
                              '낙상발생장소(코드번호로 기재)'
                                ? '236px'
                                : content.desc[i] ===
                                  '욕창 단계 (코드번호로 기재, 2개 이상일 경우 가장 높은 욕창 단계를 기재) '
                                ? '200px'
                                : '48px',
                            textAlign: 'center',
                            borderBottom:
                              i !== content.desc.length - 1
                                ? '1px solid lightgray'
                                : '',
                          }}
                        >
                          <Box
                            sx={{
                              width: '130px',
                              height:
                                content.desc[i] ===
                                '낙상발생장소(코드번호로 기재)'
                                  ? '236px'
                                  : content.desc[i] ===
                                    '욕창 단계 (코드번호로 기재, 2개 이상일 경우 가장 높은 욕창 단계를 기재) '
                                  ? '200px'
                                  : '48px',
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Form.MuiTextField
                              disabled={disabled}
                              required={false}
                              type="number"
                              inputProps={{ min, max }}
                              value={
                                content.desc[i].includes('낙상발생장소')
                                  ? input1
                                  : content.desc[i].includes(
                                      String('욕창 단계')
                                    )
                                  ? input2
                                  : 0
                              }
                              {...register(`no06_0${content.ids[i]}`, {
                                onChange: e => {
                                  var value = parseInt(e.target.value, 10);

                                  let max = { score };

                                  if (value >= max.score) value = max.score;
                                  if (value < min) value = min;

                                  if (content.desc[i].includes('낙상발생장소'))
                                    setInput1(value);
                                  else if (
                                    content.desc[i].includes('욕창 단계')
                                  )
                                    setInput2(value);
                                },
                              })}
                            />
                          </Box>
                        </TableRow>
                      );
                    })}
                  </StyledTableCellWithoutLeftRight>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
        <Box
          display={'flex'}
          sx={{ marginTop: '20px', justifyContent: 'right' }}
        >
          <Button
            size="medium"
            variant="contained"
            sx={{ mb: 2.5, width: '110px' }}
            onClick={() =>
              window.open('https://www.youtube.com/watch?v=SUhthNGZm0s')
            }
          >
            사례 동영상
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default Contents5;
